import { defModule } from '@st/redux'
import { Effect } from 'effect'
import { Analytics } from '~/effects'
import { AnalyticsEvent } from './analytics-events'
import { EventData, TrackOptions } from './core'

export type AnalyticsModuleState = null

export type AnalyticsMessage = {
  type: 'track'
  event: AnalyticsEvent
  data?: EventData
  options?: TrackOptions
}

export const analyticsModule = defModule<{
  state: AnalyticsModuleState
  message: AnalyticsMessage
}>({
  init: () => null,
  update: (state, message) => [state, trackAnalytics(message)]
})

function trackAnalytics(message: AnalyticsMessage) {
  return Effect.gen(function* () {
    const analytics = yield* Analytics
    yield* analytics.track(message.event, message.data ?? {}, message.options ?? {})
    return null
  })
}
